import angular from 'angular';

angular
    .module('app')

    .constant('API_CONFIG', {
        url: '/../kiss-boweb/proxy-epdf/api'
    })

    .constant('COUNTRIES', ['FR', 'ES', 'GB', 'IT', 'DE'])

    .constant('LANGUAGES', ['fr', 'es', 'en', 'de', 'it'])

    .constant('ENVELOPE_STATUS', [
        'ERROR',
        'REJECTED',
        'ID_TEMP',
        'WAITING_CONFIRMATION',
        'WAITING_VALIDATION',
        'PENDING',
        'CREATED',
        'TERMINATED'
    ])

    .constant('FOLDER_STATUS', ['CREATED', 'ERROR', 'VALIDATION', 'VALID', 'TERMINATED'])

    .constant('BATCH_STATUS', [
        'CREATED',
        'ERROR_DEPOSIT',
        'AVAILABLE',
        'SENT_TO_PRESTA',
        'REF_NOT_CONGRUENT',
        'RECEPTED',
        'IN_ERROR',
        'MATCHED',
        'NOT_INDEXED'
    ])
    .constant('BATCH_STATUS_REBROADCAST', ['ERROR_DEPOSIT', 'SENT_TO_PRESTA', 'AVAILABLE'])

    .constant('MESSAGE_STATUS', ['CREATED', 'SENT', 'ACQUIT_PLATFORM', 'ACQUIT_MANUALLY', 'IN_ERROR'])

    .constant('COMPANY_ID_TYPES', ['UE', 'FISCAL', 'NATIONAL'])
    .constant('INDEX_FILE_STATUS', [
        { key: 'ALL', value: 'dashboard.column.indexfile.status.ALL' },
        { key: 'OK', value: 'dashboard.column.indexfile.status.OK' },
        { key: 'ERROR', value: 'dashboard.column.indexfile.status.ERROR' }
    ])
    .constant('BATCH_PROCESS_DELAY_STATUS', [
        { key: 'BOTH', value: 'dashboard.column.batchProcessDelay.status.BOTH' },
        { key: 'MATCHED', value: 'dashboard.column.batchProcessDelay.status.MATCHED' },
        { key: 'NOT_INDEXED', value: 'dashboard.column.batchProcessDelay.status.NOT_INDEXED' }
    ])
    .constant('DOMAIN', {cegedim: 'emea.cegedim.grp'})
    .constant(
        'LIFECYCLE_STATUS',
        Object.freeze({
            EXTERNAL: 'EXTERNAL',
            DOCREPO: 'DOCREPO',
            DISPATCH: 'DISPATCH',
            SENDER: 'SENDER'
        }));
